module.exports = __webpack_public_path__ + "static/img/1.8110341.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/1.png
// module id = vkJX
// module chunks = 0